/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';
import { AppModulesEnum, WorkloadUserRolesEnum } from '../../types/user/user.types';
import {
  solar_cardTransferOutline,
  solar_chartSquareOutline,
  solar_graphUpOutline, solar_notesOutline,
} from '../../../../public/icons/solar-outline';
import { TenantsEnum } from 'app/enums/tenants.enum';
import { fluent_glanceRegular } from '../../../../public/icons/fluent-regular-24';

export const defaultNavigation: FuseNavigationItem[] = [
  {
    id: 'communication',
    title: 'Network',
    type: 'group',
    icon: 'solar_usersGroupRoundedOutline',
    children: [
      {
        id: 'news',
        title: 'Social',
        type: 'basic',
        icon: 'solar_documentAddOutline',
        classes: {
          icon: 'icon-size-5 mr-3',
        },
        link: '/social',
      },
      {
        id: 'companyNews',
        title: 'Company News',
        type: 'basic',
        icon: 'solar_inboxLineOutline',
        classes: {
          icon: 'icon-size-5 mr-3',
        },
        link: '/company-news'
      },
      {
        id: "organisationFrachtContacts",
        title: "Contacts",
        type: "basic",
        icon: "solar_notebookSquareMenuOutline",
        classes: {
          icon: 'icon-size-5 mr-3',
        },
        link: "/organisation/offices"
      },
      {
        id: "organisationFrachtAgents",
        title: "Offices",
        type: "basic",
        icon: "solar_caseRoundOutline",
        classes: {
          icon: 'icon-size-5 mr-3',
        },
        link: "/organisation/map"
      },
      {
        id: 'chat',
        title: 'Chat',
        type: 'basic',
        icon: 'solar_chatRoundOutline',
        classes: {
          icon: 'icon-size-5 mr-3',
        },
        link: '/conversations'
      }
    ],
  },
  {
    id: "content",
    title: "Content",
    type: "group",
    icon: "solar_folderOutline",
    children: [
      {
        id: "fileManagement",
        title: "File Manager",
        type: "basic",
        icon: "solar_folderOutline",
        classes: {
          icon: 'icon-size-5 mr-3',
        },
        link: "/content/file-manager"
      }
    ]
  },
  {
    id: 'masterdata',
    title: 'Master Data',
    meta: {
      tenants: [TenantsEnum.FRHROM, TenantsEnum.FRHDEM, TenantsEnum.FRHPOL, TenantsEnum.FRHUZB, TenantsEnum.FRHPOR]
    },
    type: 'basic',
    icon: 'solar_widgetOutline',
    link: '/organizations',
  },
  {
    id: 'crm',
    title: 'CRM',
    meta: {
      module: AppModulesEnum.CRM
    },
    type: 'group',
    icon: 'solar_layersMinimalisticOutline',
    children: [
      {
        id: 'overview',
        title: 'Overview',
        type: 'basic',
        icon: 'fluent_glanceRegular',
        classes: {
          icon: 'icon-size-5 mr-3',
        },
        link: '/crm/overview',
      },
      {
        id: 'contacts',
        title: 'Contacts',
        type: 'basic',
        icon: 'solar_userOutline',
        classes: {
          icon: 'icon-size-5 mr-3',
        },
        link: '/crm/contacts',
      },
      {
        id: 'accounts',
        title: 'Accounts',
        type: 'basic',
        icon: 'solar_plateOutline',
        classes: {
          icon: 'icon-size-5 mr-3',
        },
        link: '/crm/accounts',
      },
      {
        id: 'projectOpportunities',
        title: 'Opportunities',
        meta: {
          tenants: [TenantsEnum.FRHROM, TenantsEnum.FRHDEM, TenantsEnum.FRHUZB, TenantsEnum.FRHPOL, TenantsEnum.FRHPOR]
        },
        type: 'basic',
        icon: 'solar_alignLeftOutline',
        classes: {
          icon: 'icon-size-5 mr-3',
        },
        link: '/crm/opportunities',
      },
      {
        id: 'projectOpportunities',
        title: 'Project Cargo Opportunities',
        meta: {
          tenants: [TenantsEnum.FRHPRJ]
        },
        type: 'basic',
        icon: 'solar_alignLeftOutline',
        classes: {
          icon: 'icon-size-5 mr-3',
        },
        link: '/crm/opportunities',
      },
      {
        id: 'quotes',
        title: 'Quotes',
        meta: {
          tenants: [TenantsEnum.FRHROM, TenantsEnum.FRHDEM, TenantsEnum.FRHUZB, TenantsEnum.FRHPOL, TenantsEnum.FRHPOR]
        },
        type: 'basic',
        icon: 'solar_notesOutline',
        classes: {
          icon: 'icon-size-5 mr-3',
        },
        link: '/crm/quotes',
      },
      {
        id: 'cargoOpportunities',
        title: 'General Cargo Opportunities',
        meta: {
          tenants: [TenantsEnum.FRHPRJ]
        },
        type: 'basic',
        icon: 'solar_globalOutline',
        classes: {
          icon: 'icon-size-5 mr-3',
        },
        link: '/crm/cargo/opportunities',
      },
      {
        id: 'tasks',
        title: 'Tasks',
        type: 'basic',
        icon: 'solar_sortByTimeOutline',
        classes: {
          icon: 'icon-size-5 mr-3',
        },
        link: '/crm/tasks',
      },
      {
        id: 'products',
        title: 'Products',
        meta: {
          tenants: [TenantsEnum.FRHROM, TenantsEnum.FRHDEM, TenantsEnum.FRHUZB, TenantsEnum.FRHPOL, TenantsEnum.FRHPOR]
        },
        type: 'basic',
        icon: 'solar_checklistMinimalisticOutline',
        classes: {
          icon: 'icon-size-5 mr-3',
        },
        link: '/crm/products',
      },
    ],
  },
  {
    id: 'operations',
    title: 'NEW - Operations',
    meta: {
      module: AppModulesEnum.OPERATIONAL,
      role: WorkloadUserRolesEnum.USER,
    },
    type: 'group',
    icon: 'solar_routingOutline',
    children: [
      {
        id: 'financials',
        title: 'Financials',
        meta: {
          module: AppModulesEnum.OPERATIONAL,
          role: WorkloadUserRolesEnum.SUPERVISOR || WorkloadUserRolesEnum.ADMINISTRATOR,
        },
        type: 'collapsable',
        icon: 'solar_graphUpOutline',
        classes: {
          icon: 'icon-size-5 mr-3',
        },
        children: [
          {
            id: 'dashboard',
            title: 'Dashboard',
            type: 'basic',
            icon: 'solar_pieChart2Outline',
            classes: {
              icon: 'icon-size-5',
            },
            link: '/operations/financials/dashboard',
          },
          {
            id: 'cashFlow',
            title: 'Cash Flow',
            type: 'basic',
            icon: 'solar_chartSquareOutline',
            classes: {
              icon: 'icon-size-5',
            },
            link: '/operations/financials/cash-flow',
          },
        ]
      },
      {
        id: 'partners',
        title: 'Partners',
        meta: {
          module: AppModulesEnum.OPERATIONAL,
        },
        type: 'basic',
        icon: 'solar_userPlusBrokenOutline',
        classes: {
          icon: 'icon-size-5 mr-3',
        },
        link: '/operations/partners',
      },
      {
        id: 'seaFreight',
        title: 'Sea Freight',
        meta: {
          module: AppModulesEnum.OPERATIONAL_SEA,
        },
        type: 'collapsable',
        icon: 'solar_cargoShipOutline',
        classes: {
          icon: 'icon-size-5 mr-3',
        },
        children: [
          {
            id: 'seaFreightOrders',
            title: 'Shipments',
            type: 'basic',
            icon: 'solar_documentOutline',
            classes: {
              icon: 'icon-size-5',
            },
            link: '/operations/sea-freight/shipments',
          },
          {
            id: 'airFreightOrders',
            title: 'Billings',
            type: 'basic',
            icon: 'solar_fileTextOutline',
            classes: {
              icon: 'icon-size-5',
            },
            link: '/operations/sea-freight/billings',
          },
        ]
      },
      {
        id: 'airFreight',
        title: 'Air Freight',
        meta: {
          module: AppModulesEnum.OPERATIONAL_AIR,
        },
        type: 'collapsable',
        icon: 'solar_airplaneOutline',
        classes: {
          icon: 'icon-size-5 mr-3',
        },
        children: [
          {
            id: 'airFreightOrders',
            title: 'Shipments',
            type: 'basic',
            icon: 'solar_documentOutline',
            classes: {
              icon: 'icon-size-5',
            },
            link: '/operations/air-freight/shipments',
          },
          {
            id: 'airFreightBillings',
            title: 'Billings',
            type: 'basic',
            icon: 'solar_fileTextOutline',
            classes: {
              icon: 'icon-size-5',
            },
            link: '/operations/air-freight/billings',
          },
        ]
      },
      {
        id: 'road',
        title: 'Road',
        meta: {
          module: AppModulesEnum.OPERATIONAL_ROAD,
        },
        type: 'collapsable',
        icon: 'fluent_vehicleTruckProfileRegular',
        classes: {
          icon: 'icon-size-5 mr-3',
        },
        children: [
          {
            id: 'roadOrders',
            title: 'Shipments',
            type: 'basic',
            icon: 'solar_documentOutline',
            classes: {
              icon: 'icon-size-5',
            },
            link: '/operations/road/shipments',
          },
          {
            id: 'roadBillings',
            title: 'Billings',
            type: 'basic',
            icon: 'solar_fileTextOutline',
            classes: {
              icon: 'icon-size-5',
            },
            link: '/operations/road/billings',
          },
        ]
      },
    ],
  },
  {
    id: 'operational',
    title: 'Operational',
    meta: {
      module: AppModulesEnum.OPERATIONAL,
      role: WorkloadUserRolesEnum.SUPERVISOR,
    },
    type: 'group',
    icon: 'solar_routingOutline',
    children: [
      {
        id: 'seaFreight',
        title: 'Sea Freight',
        type: 'collapsable',
        icon: 'solar_cargoShipOutline',
        classes: {
          icon: 'icon-size-5 mr-3',
        },
        link: '/sea-freight',
        children: [
          {
            id: 'seaFreightOrders',
            title: 'Shipments',
            type: 'basic',
            icon: 'solar_documentOutline',
            classes: {
              icon: 'icon-size-5',
            },
            link: '/sea-freight/shipments',
          },
          {
            id: 'seaFreightTransporters',
            title: 'Partners',
            type: 'basic',
            icon: 'solar_userPlusBrokenOutline',
            classes: {
              icon: 'icon-size-5',
            },
            link: '/sea-freight/partners',
          },
          {
            id: 'seaFreightBankingDetails',
            title: 'Banking Partners',
            type: 'basic',
            icon: 'solar_usersGroupTwoRoundedOutline',
            classes: {
              icon: 'icon-size-5',
            },
            link: '/sea-freight/banking-partners',
          },
          {
            id: 'seaFreightInvoices',
            title: 'Invoices',
            type: 'basic',
            icon: 'solar_cardTransferOutline',
            classes: {
              icon: 'icon-size-5',
            },
            link: '/sea-freight/invoices',
          },
          {
            id: 'seaFreightFinancials',
            title: 'Financials',
            type: 'basic',
            icon: 'solar_chartSquareOutline',
            classes: {
              icon: 'icon-size-5',
            },
            link: '/sea-freight/financials',
          },
        ]
      },
      {
        id: 'airFreight',
        title: 'Air Freight',
        type: 'collapsable',
        icon: 'solar_airplaneOutline',
        classes: {
          icon: 'icon-size-5 mr-3',
        },
        link: '/air-freight',
        children: [
          {
            id: 'airFreightOrders',
            title: 'Shipments',
            type: 'basic',
            icon: 'solar_documentOutline',
            classes: {
              icon: 'icon-size-5',
            },
            link: '/air-freight/shipments',
          },
          {
            id: 'airFreightOrders',
            title: 'Waybills',
            type: 'basic',
            icon: 'solar_fileTextOutline',
            classes: {
              icon: 'icon-size-5',
            },
            link: '/air-freight/air-transport-order',
          },
          {
            id: 'airFreightTransporters',
            title: 'Partners',
            type: 'basic',
            icon: 'solar_userPlusBrokenOutline',
            classes: {
              icon: 'icon-size-5',
            },
            link: '/air-freight/partners',
          },
          {
            id: 'airFreightBankingDetails',
            title: 'Banking Partners',
            type: 'basic',
            icon: 'solar_usersGroupTwoRoundedOutline',
            classes: {
              icon: 'icon-size-5',
            },
            link: '/air-freight/banking-partners',
          },
          {
            id: 'airFreightInvoices',
            title: 'Invoices',
            type: 'basic',
            icon: 'solar_cardTransferOutline',
            classes: {
              icon: 'icon-size-5',
            },
            link: '/air-freight/invoices',
          },
          {
            id: 'airFreightFinancials',
            title: 'Financials',
            type: 'basic',
            icon: 'solar_chartSquareOutline',
            classes: {
              icon: 'icon-size-5',
            },
            link: '/air-freight/financials',
          },
        ]
      },
      {
        id: "financialCosts",
        title: "Financials",
        type: "basic",
        icon: "solar_chartOutline",
        classes: {
          icon: 'icon-size-5 mr-3',
        },
        link: "/financial-costs"
      }
    ],
  },
  {
    id: "clients",
    title: "Clients",
    meta: {
      module: AppModulesEnum.ADMIN
    },
    type: "basic",
    icon: "solar_shieldUserOutline",
    link: "/admin/clients"
  },
  {
    id: "userManagement",
    title: "User Management",
    meta: {
      module: AppModulesEnum.ADMIN,
      role: WorkloadUserRolesEnum.ADMINISTRATOR
    },
    type: "basic",
    icon: "solar_usersGroupRoundedOutline",
    link: "/admin/users"
  },
  {
    id: "jobsAdmin",
    title: "Job Queue",
    meta: {
      module: AppModulesEnum.ADMIN,
      role: WorkloadUserRolesEnum.ADMINISTRATOR
    },
    type: "basic",
    icon: "solar_listCheckOutline",
    link: "/admin/jobs"
  },
  {
    id: "creditRiskAdmin",
    title: "Credit Risk",
    meta: {
      module: AppModulesEnum.ADMIN,
      role: WorkloadUserRolesEnum.ADMINISTRATOR
    },
    type: "basic",
    icon: "solar_shieldUserOutline",
    link: "/admin/integrations/credit-risk"
  },
  {
    id: "automationAdmin",
    title: "Automation Rules",
    meta: {
      module: AppModulesEnum.ADMIN,
      role: WorkloadUserRolesEnum.ADMINISTRATOR
    },
    type: "basic",
    icon: "solar_alarmOutline",
    link: "/admin/automation"
  },
];
export const compactNavigation: FuseNavigationItem[] = [
  {
    id: 'communication',
    title: 'Network',
    type: 'aside',
    icon: 'solar_usersGroupRoundedOutline',
    classes: {
      icon: 'icon-size-5',
    },
    children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
  {
    id: "content",
    title: "Content",
    type: "aside",
    icon: "solar_folderOutline",
    classes: {
      icon: 'icon-size-5',
    },
    children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
  {
    id: 'masterdata',
    title: 'Master Data',
    meta: {
      tenants: [TenantsEnum.FRHROM, TenantsEnum.FRHDEM, TenantsEnum.FRHUZB, TenantsEnum.FRHPOL, TenantsEnum.FRHPOR]
    },
    type: 'basic',
    icon: 'solar_widgetOutline',
    classes: {
      icon: 'icon-size-5',
    },
    link: '/organizations',
  },
  {
    id: 'crm',
    title: 'CRM',
    meta: {
      module: AppModulesEnum.CRM
    },
    type: 'aside',
    icon: 'solar_layersMinimalisticOutline',
    classes: {
      icon: 'icon-size-5',
    },
    children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
  {
    id: 'operational',
    title: 'Operational',
    meta: {
      module: AppModulesEnum.OPERATIONAL,
      role: WorkloadUserRolesEnum.SUPERVISOR,
    },
    type: 'aside',
    icon: 'solar_routingOutline',
    classes: {
      icon: 'icon-size-5',
    },
    children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
  {
    id: 'operations',
    title: 'NEW - Operations',
    meta: {
      module: AppModulesEnum.OPERATIONAL,
      role: WorkloadUserRolesEnum.USER,
    },
    type: 'aside',
    icon: 'solar_routingOutline',
    classes: {
      icon: 'icon-size-5',
    },
    children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
  {
    id: "clients",
    meta: {
      module: AppModulesEnum.ADMIN
    },
    title: "Clients",
    type: "basic",
    icon: "solar_shieldUserOutline",
    link: "/admin/clients"
  },
  {
    id: "userManagement",
    meta: {
      module: AppModulesEnum.ADMIN,
      role: WorkloadUserRolesEnum.ADMINISTRATOR
    },
    title: "User Management",
    type: "basic",
    icon: "solar_usersGroupRoundedOutline",
    link: "/admin/users"
  },
  {
    id: "jobsAdmin",
    meta: {
      module: AppModulesEnum.ADMIN,
      role: WorkloadUserRolesEnum.ADMINISTRATOR
    },
    title: "Job Queue",
    type: "basic",
    icon: "solar_listCheckOutline",
    link: "/admin/jobs"
  },
  {
    id: "creditRiskAdmin",
    meta: {
      module: AppModulesEnum.ADMIN,
      role: WorkloadUserRolesEnum.ADMINISTRATOR
    },
    title: "Credit Risk",
    type: "basic",
    icon: "solar_shieldUserOutline",
    link: "/admin/integrations/credit-risk"
  },
  {
    id: "automationAdmin",
    meta: {
      module: AppModulesEnum.ADMIN,
      role: WorkloadUserRolesEnum.ADMINISTRATOR
    },
    title: "Automation Rules",
    type: "basic",
    icon: "solar_alarmOutline",
    link: "/admin/automation"
  },
];
export const futuristicNavigation: FuseNavigationItem[] = [
  {
    id: 'example',
    title: 'Example',
    type: 'basic',
    icon: 'heroicons_outline:chart-pie',
    link: '/example'
  }
];
export const horizontalNavigation: FuseNavigationItem[] = [
  {
    id: 'example',
    title: 'Example',
    type: 'basic',
    icon: 'heroicons_outline:chart-pie',
    link: '/example'
  }
];
